var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('vue-friendly-iframe',{ref:"frame",staticClass:"imd_frame",style:({height: _vm.iframe.height + 'px'}),attrs:{"border":"0","src":_vm.iframe.url},on:{"load":_vm.onLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }